var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.599 9a.76.76 0 00.526-.212l6.658-6.515A.727.727 0 0012 1.758a.727.727 0 00-.217-.516L10.73.212a.76.76 0 00-1.053 0L4.6 5.19 2.323 2.955a.76.76 0 00-1.053 0L.217 3.985A.727.727 0 000 4.5c0 .19.077.379.217.515l3.855 3.773A.76.76 0 004.6 9z",
    fill: "currentColor"
  })));
}
export default SvgCheck;